import { observer } from 'mobx-react'
import {
  type ButtonHTMLAttributes,
  type DetailedHTMLProps,
  type FC,
  type SVGProps
} from 'react'
import style from './Button.module.css'

export interface ButtonProps
  extends DetailedHTMLProps<
    ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  label: string
  filled?: boolean
  width?: string
  size?: 'medium' | 'large'
  Icon?: FC<SVGProps<SVGSVGElement>>
  type?: 'button' | 'submit' | 'reset' | undefined
  customCSS?: string
  defaultColor?: boolean
  isLoading?: boolean
}

export const Button: FC<ButtonProps> = observer((props) => {
  const {
    label,
    filled = true,
    width,
    size = 'medium',
    Icon,
    onClick,
    type = 'button',
    customCSS = '',
    isLoading = false,
    defaultColor = true,
    ...btnProps
  } = props
  const mode = !filled ? style.bordered : defaultColor ? style.filled : ''
  const sizeStyle = size === 'medium' ? style.medium : style.large
  return (
    <>
      <button
        className={[
          style.button,
          defaultColor ? style.color_default : '',
          'select-none',
          mode,
          sizeStyle,
          isLoading ? style['loader-padding'] : '',
          customCSS
        ].join(' ')}
        onClick={onClick}
        type={type}
        {...btnProps}
      >
        {Icon && <Icon fill="#FFFFFF" className={style.button_icon} />}
        {!isLoading && label}
        {isLoading && (
          <div
            className={
              style.loader +
              ' loader mt-px ease-linear rounded-full border-4 border-t-4 border-gray-200'
            }
          ></div>
        )}
      </button>
    </>
  )
})

export default Button
